// Generated by ReScript, PLEASE EDIT WITH CARE


var dummyResponse = {
	"external_id": "uuid",
	"mobile" : "9999999999",
	"first_name": "John",
	"last_name": "Doe",
	"address": null,
	"company_name": null,
	"blacklisted": true,
	"mail_info": 
	{
		"email" : "john.doe@example.com",
		"is_verified": false
	}
};

export {
  dummyResponse ,
}
/* No side effect */
